

































import {Vue} from "vue-property-decorator";
import Component from "vue-class-component";
import {MetadataBackup} from "@/assets/ts/MetadataBackup";
import VideoIdTable from "@/components/VideoIdTable.vue";

import ExecutionResult = MetadataBackup.Response.ExecutionResult;
import VideoAddResult = MetadataBackup.Response.VideoAddResult;

@Component({
  components: {VideoIdTable}
})
export default class BackupResultModel extends Vue {
  private show = false;
  private response: ExecutionResult<VideoAddResult> | null = null;

  public showModal(): void { this.show = true; }
  public hideModal(): void { this.show = false; }
  public toggleModal(): void { this.show = !this.show; }

  public SetBackupResult(result: ExecutionResult<VideoAddResult>): void
  {
    this.response = result;
    this.showModal();
  }
}
